const initCollectionGrid = () => {
  // --- Layout column switcher logic ---
  // La vista móvil por defecto es de 1 columna (los acabados de la tarjeta se ven mejor). La clave es «-v2»
  // para que una elección antigua de 2 columnas no se arrastre: el visitante vuelve a la vista de 1.
  const CLAVE_COLS_MOVIL = 'lg-cols-mobile-v2';
  const savedColsDesktop = localStorage.getItem('lg-cols-desktop');
  const savedColsMobile = localStorage.getItem(CLAVE_COLS_MOVIL);
  const grid = document.getElementById('product-grid');

  const applyGridClasses = () => {
    const activeGrid = document.getElementById('product-grid');
    if (!activeGrid) return;
    if (savedColsDesktop) {
      activeGrid.className = activeGrid.className.replace(/grid--\d-col-desktop/g, '').trim();
      activeGrid.classList.add(`grid--${savedColsDesktop}-col-desktop`);
      document.querySelectorAll('.lg-layout-btn--desktop').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.colsDesktop === savedColsDesktop);
      });
    }
    if (savedColsMobile) {
      activeGrid.className = activeGrid.className.replace(/grid--\d-col-tablet-down/g, '').trim();
      activeGrid.classList.add(`grid--${savedColsMobile}-col-tablet-down`);
      document.querySelectorAll('.lg-layout-btn--mobile').forEach(btn => {
        btn.classList.toggle('active', btn.dataset.colsMobile === savedColsMobile);
      });
    }
  };

  // Si el visitante aún no ha elegido vista, se marca como activa la predeterminada de su resolución
  // (1 · 2 · 4 · 6 columnas, calculada por CSS) para que el selector no aparezca sin ninguna activa.
  const markCurrentView = () => {
    const activeGrid = document.getElementById('product-grid');
    if (!activeGrid) return;
    const cols = getComputedStyle(activeGrid).gridTemplateColumns.split(' ').filter(Boolean).length;
    const isDesktop = window.matchMedia('(min-width: 750px)').matches;
    const selector = isDesktop ? '.lg-layout-btn--desktop' : '.lg-layout-btn--mobile';
    const hasSaved = isDesktop ? savedColsDesktop : savedColsMobile;
    if (hasSaved) return;
    document.querySelectorAll(selector).forEach((btn) => {
      const v = btn.dataset.colsDesktop || btn.dataset.colsMobile;
      btn.classList.toggle('active', Number(v) === cols);
    });
  };

  if (grid) {
    applyGridClasses();
    markCurrentView();
    window.addEventListener('resize', markCurrentView);
  }

  // Usar delegación de eventos en document para que el cambio de columnas no deje de funcionar después de un filtrado AJAX
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.lg-layout-btn');
    if (!btn) return;

    const activeGrid = document.getElementById('product-grid');
    if (!activeGrid) return;

    if (btn.dataset.colsDesktop) {
      const cols = btn.dataset.colsDesktop;
      document.querySelectorAll('.lg-layout-btn--desktop').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      activeGrid.className = activeGrid.className.replace(/grid--\d-col-desktop/g, '').trim();
      activeGrid.classList.add(`grid--${cols}-col-desktop`);
      localStorage.setItem('lg-cols-desktop', cols);
    } else if (btn.dataset.colsMobile) {
      const cols = btn.dataset.colsMobile;
      document.querySelectorAll('.lg-layout-btn--mobile').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');

      activeGrid.className = activeGrid.className.replace(/grid--\d-col-tablet-down/g, '').trim();
      activeGrid.classList.add(`grid--${cols}-col-tablet-down`);
      localStorage.setItem(CLAVE_COLS_MOVIL, cols);
    }
  });

  // --- AJAX Load More + scroll infinito ---
  // Un IntersectionObserver vigila el botón "ver más": cuando se acerca al
  // viewport, dispara la carga automáticamente. El botón se conserva como
  // fallback (clic manual y accesibilidad/SEO) pero rara vez hace falta.
  let isLoadingMore = false;

  const loadMoreObserver = new IntersectionObserver((entries) => {
    if (entries.some((entry) => entry.isIntersecting)) {
      triggerLoadMore();
    }
  }, { rootMargin: '400px 0px' });

  const observeLoadMore = () => {
    const btn = document.querySelector('.lg-load-more-btn');
    if (btn) loadMoreObserver.observe(btn);
  };

  function triggerLoadMore() {
    const btn = document.querySelector('.lg-load-more-btn');
    if (!btn || isLoadingMore) return;

    const nextUrl = btn.dataset.nextUrl;
    if (!nextUrl) return;

    isLoadingMore = true;
    loadMoreObserver.disconnect();
    btn.classList.add('loading');
    btn.setAttribute('disabled', 'disabled');

    fetch(nextUrl)
      .then((res) => res.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Añadir los nuevos productos respetando el orden en que llegan
        const newGridItems = doc.querySelectorAll('#product-grid > li.grid__item');
        const activeGrid = document.getElementById('product-grid');
        if (activeGrid && newGridItems.length > 0) {
          newGridItems.forEach((item) => {
            item.classList.add('lg-fade-in-entry');
            activeGrid.appendChild(item);
          });
        }

        // Actualizar el contador de la barra de herramientas
        const newToolbarCount = doc.querySelector('.lg-grid-toolbar__count');
        const currentToolbarCount = document.querySelector('.lg-grid-toolbar__count');
        if (currentToolbarCount && newToolbarCount) {
          currentToolbarCount.innerHTML = newToolbarCount.innerHTML;
        }

        // Reemplazar el contenedor de "ver más" (progreso + botón de la página siguiente)
        const currentContainer = document.querySelector('.lg-load-more-container');
        const newContainer = doc.querySelector('.lg-load-more-container');
        if (currentContainer && newContainer) {
          currentContainer.outerHTML = newContainer.outerHTML;
        } else if (currentContainer) {
          currentContainer.remove();
        }

        // Actualizar la URL sin recargar
        window.history.replaceState({}, '', nextUrl);
      })
      .catch((err) => {
        console.error('Error loading more products:', err);
      })
      .finally(() => {
        isLoadingMore = false;
        // Re-observar el nuevo botón si queda otra página
        observeLoadMore();
      });
  }

  // Fallback: el clic manual sigue funcionando
  document.addEventListener('click', function (e) {
    if (e.target.closest('.lg-load-more-btn')) {
      e.preventDefault();
      triggerLoadMore();
    }
  });

  // Arrancar el scroll infinito
  observeLoadMore();

  // Re-observar el botón tras un filtrado/orden AJAX (Dawn reemplaza el grid)
  document.addEventListener('shopify:section:load', () => {
    applyGridClasses();
    observeLoadMore();
  });
  const gridObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.addedNodes.length > 0) {
        applyGridClasses();
        observeLoadMore();
      }
    });
  });
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer) {
    gridObserver.observe(gridContainer, { childList: true });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCollectionGrid, { once: true });
} else {
  initCollectionGrid();
}
